import { Avatar } from "@mui/material";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useECatalogueSequenceUpdateMutation } from "../../../../features/tenant/eCatalogue/eCatalogueApi";

const ReOrderECatalogueList = ({ data , closeModal }) => {
  const [items, setItems] = useState(data);
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.setData("text/plain", index);
    e.target.style.opacity = "0.1";
  };

  const handleDragEnd = (e) => {
    e.target.style.opacity = "1";
    setDraggedIndex(null);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = parseInt(e.dataTransfer.getData("text/plain"), 10);
    if (dragIndex !== dropIndex) {
      setItems((prevItems) => {
        const updatedItems = [...prevItems];
        const [draggedItem] = updatedItems.splice(dragIndex, 1);
        updatedItems.splice(dropIndex, 0, draggedItem);
        return updatedItems.map((item, idx) => ({ ...item, sequence: idx }));
      });
    }
  };


  const [updateECatalogueSequence, { data: updateECatalogueSequenceData, error: updateECatalogueSequenceError, isLoading: updateECatalogueSequenceIsLoading }] =
  useECatalogueSequenceUpdateMutation();

  const handleSaveReOrderedList = (e) => {
    e.preventDefault();

    const body = items.map((item) => ({ id: item.id, sequence: item.sequence }));
    console.log("body", body);

    if (window.confirm("are you sure ?")) {
      updateECatalogueSequence({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: {
          "data": body
        },
      });
    }
  };


  useEffect(() => {

    if(updateECatalogueSequenceData){
      toast.dismiss();
      console.log("updateECatalogueSequenceData", updateECatalogueSequenceData);
      closeModal();

    }



    if(updateECatalogueSequenceIsLoading){
      toast.loading("Updating...")
      console.log("updateECatalogueSequenceIsLoading", updateECatalogueSequenceIsLoading);
    }


    if(updateECatalogueSequenceError){
      toast.dismiss();
      console.log("updateECatalogueSequenceError", updateECatalogueSequenceError);
      closeModal();
    }
  }, [updateECatalogueSequenceData, updateECatalogueSequenceError , updateECatalogueSequenceIsLoading])
  
  return (
    <div className="mx-5 my-5 bg-white">
      <h1 className="text-xl font-semibold mb-4 text-center">Drag & Drop to Reorder</h1>
      <div>
        {items.map((item, index) => (
          <div
            key={item.id}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragEnd={handleDragEnd}
            onDragOver={(e) => handleDragOver(e, index)}
            onDrop={(e) => handleDrop(e, index)}
            className={`p-4 mb-2 bg-gray-100 rounded-lg shadow-md flex justify-between items-center cursor-move ${draggedIndex === index ? "opacity-50" : "opacity-100"
              } transition-opacity duration-200`}
          >
            <Avatar
              alt="reorder-image-show"
              src={item?.image ? item?.image : ""}
            />
            <div className="w-3/4">
              <span>Name: {item.name}</span>
              <br />
              <span>Type: {item.type}</span>
            </div>
            <span className="text-gray-500">Seq : {item.sequence}</span>
          </div>
        ))}
      </div>
      <div className="flex justify-center mt-3">
        <button
          type="submit"
          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          onClick={(e) => handleSaveReOrderedList(e)}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ReOrderECatalogueList;